import { Template } from "chq";
import { activisionImageTemplates, bostonScientificImageTemplates, defaultImageTemplates, intelliaImageTemplates, intuitiveImageTemplates, ircDefaultImageTemplates, ircImageTemplates, zendeskImageTemplates } from "../sidebar/tabs/template/templates";

const getImageTemplatesByOrg = (organizationName: string): Template[] => {
  if (organizationName === "Activision Blizzard") {
    return [...activisionImageTemplates, ...defaultImageTemplates];
  }
  if (organizationName === "Boston Scientific") {
    return [...bostonScientificImageTemplates, ...defaultImageTemplates];
  }
  if (organizationName === "Intellia Therapeutics") {
    return intelliaImageTemplates;
  }
  if (organizationName === "Intuitive") {
    return [...intuitiveImageTemplates, ...defaultImageTemplates];
  }
  if (organizationName === "International Rescue Committee") {
    return [...ircImageTemplates, ...ircDefaultImageTemplates];
  }
  if (organizationName === "Zendesk" || organizationName === "Zendesk Working Space") {
    const curratedImageTemplates = defaultImageTemplates.slice(2);
    return [...zendeskImageTemplates, ...curratedImageTemplates];
  }
  return defaultImageTemplates;
};

export default getImageTemplatesByOrg;
